import http from '../../../utils/fetch';

export default {
    page(v) {
        return http({
            url: '/api/swyl/v1/demo/bscForecastplan/selectPage',
            method: 'post',
            params: v
        });
    },
    showPage(v) {
        return http({
            url: '/api/swyl/v1/demo/bscForecastplan/showPage',
            method: 'post',
            params: v
        });
    },
    selectDa(v) {
        return http.post('/api/swyl/v1/demo/bscForecastplan/selectData',v);
    }
}